
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/skill-xp/[skillB2BUserId]/[slug]/resultados",
      function () {
        return require("private-next-pages/skill-xp/[skillB2BUserId]/[slug]/resultados.ts");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/skill-xp/[skillB2BUserId]/[slug]/resultados"])
      });
    }
  